import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { InformationComponent } from './information.component';

const informationRoutes: Routes = [
  { path: '', component: InformationComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(informationRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class InformationRoutingModule { }




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/information/information.routing.ts